import QRCode from 'qrcode'

export default {
  name: 'Qrcode',

  props: {
    content: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    type: {

    },
    margin:{
      type:Number,
      default:0
    },
    transparent:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    content(val){
      if(val) this.render()
    }
  },
  mounted(){
    if(this.content){
      this.render()
    }
  },
  methods: {
    render(name) {
      let options = {
        margin:this.margin , width:this.width , height:this.height,
      }

      if(this.transparent){
        options.color = {
          light: '#0000' // Transparent background
        }
      }

      QRCode.toCanvas(this.$el , this.content, options , (err, data) => {
        if (err) throw err
      })
    }
  },
  render(){
    return <canvas></canvas>
  }
}

